import { SYSTEM_ASSIGNMENT_DEFAULTS } from 'utils/assignmentDefaults';
import { getHTMLWordCount, isFeedbackSettingsDefault } from 'utils/helper';

export const getQuizFeedbackDefaults = () => ({
    aiFeedbackEnabled: SYSTEM_ASSIGNMENT_DEFAULTS.aiFeedbackEnabled,
    feedbackSettings: { ...SYSTEM_ASSIGNMENT_DEFAULTS.feedbackSettings, feedbackExamples: [''] },
    feedbackCustomContext: '',
});

export const isQuizFeedbackSettingsDefault = (settings, context = '') =>
    isFeedbackSettingsDefault(settings) &&
    getHTMLWordCount(context) === 0 &&
    !(settings.feedbackExamples || []).some((example) => getHTMLWordCount(example) > 0);
